(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["az-cart-explore-categories"] && !Shopify.designMode) return;
  try {
    
class AzCartExplore extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.#activate(tab.dataset.tab));
    });
  }

  #activate(id) {
    let activePanel;
    this.panels.forEach((panel) => {
      const active = panel.dataset.panel === id;
      panel.hidden = !active;
      if (active) activePanel = panel;
    });
    this.tabs.forEach((tab) => {
      const active = tab.dataset.tab === id;
      tab.classList.toggle('az-cart-explore__tab--active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    const slider = activePanel && activePanel.querySelector('slider-component');
    if (slider && typeof slider.resetPages === 'function') slider.resetPages();
  }
}

customElements.define('az-cart-explore', AzCartExplore);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-collection-seo-text"] && !Shopify.designMode) return;
  try {
    
class AzSeoReveal extends HTMLElement {
  connectedCallback() {
    const sections = this.#groupIntoSections();
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.#observeReveal(sections);
  }

  #groupIntoSections() {
    const nodes = Array.from(this.children);
    if (!nodes.length) return [];

    const sections = [];
    let current = null;

    nodes.forEach((node) => {
      if (node.tagName === 'H3' || !current) {
        current = document.createElement('div');
        current.className = 'az-seo-text__section';
        this.appendChild(current);
        sections.push(current);
      }
      current.appendChild(node);
    });

    return sections;
  }

  #observeReveal(sections) {
    if (!sections.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('az-seo-reveal__item--visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
    );

    sections.forEach((section) => {
      section.classList.add('az-seo-reveal__item');
      observer.observe(section);
    });
  }
}

customElements.define('az-seo-reveal', AzSeoReveal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-hero-categorias"] && !Shopify.designMode) return;
  try {
    
class AzHeroCategorias extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
    this.slides = Array.from(this.querySelectorAll('[data-slide]'));
    this.panels = Array.from(this.querySelectorAll('[data-panel-for]'));
    this.mediaLink = this.querySelector('[data-media-link]');
    this.priceWrap = this.querySelector('[data-price]');
    this.priceAmount = this.querySelector('[data-price-amount]');

    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.autoplayEnabled = this.dataset.autoplay === 'true' && !this.reduceMotion;
    this.autoplayInterval = parseInt(this.dataset.autoplayInterval, 10) || 4000;
    this.photoTimer = null;
    this.paused = false;

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        this.#activate(tab.dataset.tab);
        this.scrollIntoView({ behavior: this.reduceMotion ? 'auto' : 'smooth', block: 'start' });
      });
    });

    this.addEventListener('mouseenter', () => { this.paused = true; });
    this.addEventListener('mouseleave', () => { this.paused = false; });
    this.addEventListener('focusin', () => { this.paused = true; });
    this.addEventListener('focusout', () => { this.paused = false; });

    this.addEventListener('shopify:block:select', (event) => {
      const blockId = event.detail.blockId;
      const isCategoryBlock = this.tabs.some((tab) => tab.dataset.tab === blockId);
      if (isCategoryBlock) this.#activate(blockId, true);
    });
    this.addEventListener('shopify:block:deselect', () => {
      this.#activate('neutral');
    });

    this.#activate('neutral');
  }

  disconnectedCallback() {
    if (this.photoTimer) clearInterval(this.photoTimer);
  }

  #activate(id, fromEditor) {
    const isValidId = id === 'neutral' || this.tabs.some((tab) => tab.dataset.tab === id);
    if (!isValidId) return;

    if (this.photoTimer) clearInterval(this.photoTimer);

    this.slides.forEach((slide) => { slide.hidden = slide.dataset.slide !== id; });
    this.panels.forEach((panel) => { panel.hidden = panel.dataset.panelFor !== id; });

    const activeTab = this.tabs.find((tab) => tab.dataset.tab === id);
    this.tabs.forEach((tab) => {
      const active = tab === activeTab;
      tab.classList.toggle('az-hero__tab--active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    });

    if (this.mediaLink) {
      if (activeTab && activeTab.dataset.link) {
        this.mediaLink.setAttribute('href', activeTab.dataset.link);
        this.mediaLink.hidden = false;
      } else {
        this.mediaLink.hidden = true;
      }
    }

    if (this.priceWrap && this.priceAmount) {
      const price = id === 'neutral' ? this.dataset.neutralPrice : (activeTab ? activeTab.dataset.price : '');
      if (price) {
        this.priceAmount.textContent = price;
        this.priceWrap.hidden = false;
      } else {
        this.priceWrap.hidden = true;
      }
    }

    const activeSlide = this.slides.find((slide) => slide.dataset.slide === id);
    if (activeSlide) this.#startPhotoCarousel(activeSlide);

    if (fromEditor && activeSlide) {
      activeSlide.scrollIntoView({ block: 'nearest' });
    }
  }

  #startPhotoCarousel(slide) {
    const photos = Array.from(slide.querySelectorAll('[data-photo-index]'));
    const dotsWrap = slide.querySelector('[data-dots]');
    let index = 0;

    const render = () => {
      photos.forEach((photo, i) => { photo.hidden = i !== index; });
      if (dotsWrap) {
        Array.from(dotsWrap.children).forEach((dot, i) => dot.classList.toggle('az-hero__dot--active', i === index));
      }
    };

    const goTo = (next) => {
      index = next;
      render();
      restartTimer();
    };

    const restartTimer = () => {
      if (this.photoTimer) clearInterval(this.photoTimer);
      if (!this.autoplayEnabled || photos.length < 2) return;
      this.photoTimer = setInterval(() => {
        if (this.paused) return;
        index = (index + 1) % photos.length;
        render();
      }, this.autoplayInterval);
    };

    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      if (photos.length > 1) {
        photos.forEach((_, i) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'az-hero__dot';
          dot.setAttribute('aria-label', `Foto ${i + 1}`);
          dot.addEventListener('click', () => goTo(i));
          dotsWrap.appendChild(dot);
        });
      }
    }

    render();
    restartTimer();
  }
}

customElements.define('az-hero-categorias', AzHeroCategorias);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["az-whatsapp-button"]) return;
  try {
    
class AzWhatsappButton extends HTMLElement {
  connectedCallback() {
    if (this.parentElement !== document.body) {
      document.body.appendChild(this);
    }

    this.stickyBar = document.querySelector('az-sticky-atc');
    if (!this.stickyBar) return;

    this.#syncOffset();
    this.observer = new MutationObserver(() => this.#syncOffset());
    this.observer.observe(this.stickyBar, { attributes: true, attributeFilter: ['class'] });
    this.resizeHandler = () => this.#syncOffset();
    window.addEventListener('resize', this.resizeHandler);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    if (this.resizeHandler) window.removeEventListener('resize', this.resizeHandler);
  }

  #syncOffset() {
    const isVisible = this.stickyBar.classList.contains('az-sticky-atc--visible');
    const offset = isVisible ? this.stickyBar.getBoundingClientRect().height : 0;
    this.style.setProperty('--az-wa-offset', `${offset}px`);
    this.#syncBackToTop(offset);
  }

  #syncBackToTop(offset) {
    const backToTop = document.querySelector('[class^="top-template--"]');
    if (!backToTop) return;
    if (offset > 0) {
      backToTop.style.bottom = `calc(${offset}px + 16px)`;
    } else {
      backToTop.style.removeProperty('bottom');
    }
  }
}

customElements.define('az-whatsapp-button', AzWhatsappButton);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
